import { DebugCallQuality } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugCallQuality';
import { DebugConnectionHealth } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugConnectionHealth';
import type { DebugRecordOverviewProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordOverview/index.types';
import { DebugScenarioSummary } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugScenarioSummary';
import React from 'react';

/**
 * DebugRecordOverview - What kind of call this was, and how it ended
 *
 * The scenario comes first because it is the context that makes the rest
 * readable:
 */
export const DebugRecordOverview: React.FC<DebugRecordOverviewProps> = ({
  info,
  onOpenLeg,
  availableLegIds,
}) => (
  <div className="flex flex-col gap-3">
    <DebugScenarioSummary
      info={info}
      onOpenLeg={onOpenLeg}
      availableLegIds={availableLegIds}
    />
    <DebugConnectionHealth info={info} />
    {/* Health says the path came up; quality says whether it carried anything. */}
    <DebugCallQuality info={info} />
  </div>
);
